module.exports = __webpack_public_path__ + "assets/images/16-wp5zuoo.jpg";